import { render, staticRenderFns } from "./ListaAnuncios.vue?vue&type=template&id=888b594a&scoped=true&"
import script from "./ListaAnuncios.vue?vue&type=script&lang=js&"
export * from "./ListaAnuncios.vue?vue&type=script&lang=js&"
import style0 from "./ListaAnuncios.vue?vue&type=style&index=0&id=888b594a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888b594a",
  null
  
)

export default component.exports